// Cache busting utility for React app
class CacheBuster {
  constructor() {
    this.version = process.env.REACT_APP_VERSION || Date.now().toString();
    this.lastCheck = localStorage.getItem('lastCacheCheck') || 0;
    this.checkInterval = 5 * 60 * 1000; // Check every 5 minutes
  }

  // Force reload the application
  forceReload() {
    console.log('Force reloading application...');
    window.location.reload(true);
  }

  // Check if cache needs to be cleared
  shouldClearCache() {
    const now = Date.now();
    const timeSinceLastCheck = now - parseInt(this.lastCheck);
    
    if (timeSinceLastCheck > this.checkInterval) {
      this.lastCheck = now.toString();
      localStorage.setItem('lastCacheCheck', this.lastCheck);
      return true;
    }
    return false;
  }

  // Clear only static asset caches, not API data
  clearAllCaches() {
    // Clear localStorage (but keep important user data)
    const keysToKeep = ['lastCacheCheck', 'userPreferences', 'authToken', 'userData'];
    const allKeys = Object.keys(localStorage);
    allKeys.forEach(key => {
      if (!keysToKeep.includes(key)) {
        localStorage.removeItem(key);
      }
    });

    // Clear sessionStorage (but keep API session data)
    const sessionKeysToKeep = ['apiSession', 'socketSession'];
    const sessionKeys = Object.keys(sessionStorage);
    sessionKeys.forEach(key => {
      if (!sessionKeysToKeep.includes(key)) {
        sessionStorage.removeItem(key);
      }
    });

    // Clear service worker cache for static assets only
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({type: 'CLEAR_CACHE'});
    }

    // Clear browser cache for static assets only
    if ('caches' in window) {
      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          // Only clear static asset caches, not API caches
          if (cacheName.includes('static') || cacheName.includes('admin-frontend')) {
            caches.delete(cacheName);
          }
        });
      });
    }
  }

  // Initialize cache busting
  init() {
    // Check on app start
    if (this.shouldClearCache()) {
      this.clearAllCaches();
    }

    // Set up periodic checks
    setInterval(() => {
      if (this.shouldClearCache()) {
        this.clearAllCaches();
      }
    }, this.checkInterval);

    // Removed automatic reload on tab change - only check on app start
  }

  // Get cache-busted URL for API calls
  getCacheBustedUrl(url) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}_cb=${this.version}`;
  }
}

// Create singleton instance
const cacheBuster = new CacheBuster();

export default cacheBuster;
